// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.conf-status[data-v-7cde1d3e] {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: var(--bg-color-video-cont);
  display: flex;
  flex-direction: column;
}
.conf-status *[data-v-7cde1d3e] {
  margin-left: auto;
  margin-right: auto;
}
.conf-status *[data-v-7cde1d3e]:first-child {
  margin-top: auto;
}
.conf-status *[data-v-7cde1d3e]:last-child {
  margin-bottom: auto;
}
.conf-status .status-text[data-v-7cde1d3e] {
  text-align: center;
  color: white;
}
.conf-status .buttons[data-v-7cde1d3e] {
  margin-top: 10px;
}
.buttons[data-v-7cde1d3e] {
  display: flex;
}
.buttons .handup-wrapper[data-v-7cde1d3e],
.buttons .reactions-wrapper[data-v-7cde1d3e] {
  margin: 10px;
  border-radius: 10px;
  background: var(--vm-handup-wrapper-bg);
  color: white;
}
.buttons .handup-wrapper[data-v-7cde1d3e]:not(:first-child),
.buttons .reactions-wrapper[data-v-7cde1d3e]:not(:first-child) {
  margin-top: 0;
}
.buttons .handup-wrapper[data-v-7cde1d3e] {
  display: flex;
  flex-direction: row;
  padding: 10px;
  cursor: pointer;
}
.buttons .handup-wrapper[data-v-7cde1d3e]:hover {
  background-color: var(--bg-color-hover);
}
.buttons .handup-wrapper > *[data-v-7cde1d3e]:first-child {
  margin-left: auto;
  margin-right: 5px;
}
.buttons .handup-wrapper > *[data-v-7cde1d3e]:last-child {
  margin-right: auto;
}
`, "",{"version":3,"sources":["webpack://./js/app/components/videoConfNew/videoConfStatus.vue"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,OAAO;EACP,QAAQ;EACR,4CAA4C;EAC5C,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;;EAEE,YAAY;EACZ,mBAAmB;EACnB,uCAAuC;EACvC,YAAY;AACd;AACA;;EAEE,aAAa;AACf;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,eAAe;AACjB;AACA;EACE,uCAAuC;AACzC;AACA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB","sourcesContent":[".conf-status[data-v-7cde1d3e] {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background-color: var(--bg-color-video-cont);\n  display: flex;\n  flex-direction: column;\n}\n.conf-status *[data-v-7cde1d3e] {\n  margin-left: auto;\n  margin-right: auto;\n}\n.conf-status *[data-v-7cde1d3e]:first-child {\n  margin-top: auto;\n}\n.conf-status *[data-v-7cde1d3e]:last-child {\n  margin-bottom: auto;\n}\n.conf-status .status-text[data-v-7cde1d3e] {\n  text-align: center;\n  color: white;\n}\n.conf-status .buttons[data-v-7cde1d3e] {\n  margin-top: 10px;\n}\n.buttons[data-v-7cde1d3e] {\n  display: flex;\n}\n.buttons .handup-wrapper[data-v-7cde1d3e],\n.buttons .reactions-wrapper[data-v-7cde1d3e] {\n  margin: 10px;\n  border-radius: 10px;\n  background: var(--vm-handup-wrapper-bg);\n  color: white;\n}\n.buttons .handup-wrapper[data-v-7cde1d3e]:not(:first-child),\n.buttons .reactions-wrapper[data-v-7cde1d3e]:not(:first-child) {\n  margin-top: 0;\n}\n.buttons .handup-wrapper[data-v-7cde1d3e] {\n  display: flex;\n  flex-direction: row;\n  padding: 10px;\n  cursor: pointer;\n}\n.buttons .handup-wrapper[data-v-7cde1d3e]:hover {\n  background-color: var(--bg-color-hover);\n}\n.buttons .handup-wrapper > *[data-v-7cde1d3e]:first-child {\n  margin-left: auto;\n  margin-right: 5px;\n}\n.buttons .handup-wrapper > *[data-v-7cde1d3e]:last-child {\n  margin-right: auto;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
